<template>
  <div class="gameBox">
    <swiper class="swiper" ref="mySwiper" :options="swiperOption" @slideChangeTransitionStart="handleClickSlide">
      <swiper-slide class="backcolor">
        <img src="../assets/expertimg/back-head.jpg" class="">
        <div class="gameBox-1" :class="num==0?'animate__animated animate__bounceInLeft animate__delay-0s':''"><img src="../assets/expertimg/back-1-1.png"></div>
        <div class="gameBox-2" :class="num==0?'animate__animated animate__bounceInLeft animate__delay-1s':''"><img src="../assets/expertimg/back-1-2.png"></div>
        <div class="gameBox-3" :class="num==0?'animate__animated animate__bounceInLeft animate__delay-2s':''"><img src="../assets/expertimg/back-1-3.png"></div>
        <div class="gameBox-4" :class="num==0?'animate__animated animate__backInUp animate__delay-0s':''" @click="next"><img src="../assets/expertimg/down.png"></div>
      </swiper-slide>
      <swiper-slide>
        <img class="backimg" src="../assets/expertimg/back-3.png">
        <div class="gameBox-8" :class="num==1?'animate__animated animate__fadeInDown animate__delay-0s':''"><img src="../assets/expertimg/back-3-1.png"></div>
        <div class="gameBox-9" :class="num==1?'animate__animated animate__fadeInUp animate__delay-1s':''"><img src="../assets/expertimg/back-3-2.png"></div>
        <div class="gameBox-15" :class="num==1?'animate__animated animate__fadeInUp animate__delay-1s':''"><img src="../assets/expertimg/back-3-3.png"></div>
        <div class="gameBox-16" :class="num==1?'animate__animated animate__fadeInUp animate__delay-1s':''"><img src="../assets/expertimg/back-3-4.png"></div>
        <div class="gameBox-17" :class="num==1?'animate__animated animate__fadeInUp animate__delay-1s':''"><img src="../assets/expertimg/back-3-5.png"></div>
        <div class="gameBox-4" :class="num==1?'animate__animated animate__backInUp animate__delay-0s':''" @click="next"><img src="../assets/expertimg/down.png"></div>
      </swiper-slide>
      <swiper-slide>
        <img class="backimg" src="../assets/expertimg/back-4.png">
        <div class="gameBox-8 " :class="num==2?'animate__animated animate__fadeInDown animate__delay-0s':''"><img src="../assets/expertimg/back-4-1.png"></div>
        <div class="gameBox-13" :class="num==2?'animate__animated animate__slideInUp animate__delay-0s':''"><img src="../assets/expertimg/back-4-2.png"></div>
        <div class="gameBox-4" :class="num==2?'animate__animated animate__backInUp animate__delay-0s':''" @click="next"><img src="../assets/expertimg/down.png"></div>
      </swiper-slide>
      <swiper-slide>
        <img class="backimg" src="../assets/expertimg/back-5.png">
        <div class="gameBox-8" :class="num==3?'animate__animated animate__fadeInDown animate__delay-0s':''"><img src="../assets/expertimg/back-5-1.png"></div>
        <div class="gameBox-10" :class="num==3?'animate__animated animate__slideInUp animate__delay-0s':''"><img src="../assets/expertimg/back-5-2.png"></div>
        <div class="gameBox-4" :class="num==3?'animate__animated animate__backInUp animate__delay-0s':''" @click="next"><img src="../assets/expertimg/down.png"></div>
      </swiper-slide>
      <swiper-slide>
        <img class="backimg" src="../assets/expertimg/back-5.png">
        <div class="gameBox-8" :class="num==4?'animate__animated animate__fadeInDown animate__delay-0s':''"><img src="../assets/expertimg/back-6-1.png"></div>
        <div class="gameBox-12" :class="num==4?'animate__animated animate__slideInLeft animate__delay-0s':''"><img src="../assets/expertimg/back-6-2.png"></div>
        <div class="gameBox-4" :class="num==4?'animate__animated animate__backInUp animate__delay-0s':''" @click="next"><img src="../assets/expertimg/down.png"></div>
      </swiper-slide>
      <swiper-slide>
        <img class="backimg" src="../assets/expertimg/back-3.png">
        <div class="gameBox-8" :class="num==5?'animate__animated animate__fadeInDown animate__delay-0s':''"><img src="../assets/expertimg/back-7-1.png"></div>
        <div class="gameBox-10" :class="num==5?'animate__animated animate__slideInUp animate__delay-0s':''"><img src="../assets/expertimg/back-7-2.png"></div>
        <div class="gameBox-4" :class="num==5?'animate__animated animate__backInUp animate__delay-0s':''" @click="next"><img src="../assets/expertimg/down.png"></div>
      </swiper-slide>
      <swiper-slide>
        <img class="backimg" src="../assets/expertimg/back-4.png">
        <div class="gameBox-8" :class="num==6?'animate__animated animate__fadeInDown animate__delay-0s':''"><img src="../assets/expertimg/back-8-1.png"></div>
        <div class="gameBox-10" :class="num==6?'animate__animated animate__slideInUp animate__delay-0s':''"><img src="../assets/expertimg/back-8-2.png"></div>
        <div class="gameBox-4" :class="num==6?'animate__animated animate__backInUp animate__delay-0s':''" @click="next"><img src="../assets/expertimg/down.png"></div>
      </swiper-slide>
      <swiper-slide>
        <img class="backimg" src="../assets/expertimg/back-3.png">
        <div class="gameBox-8" :class="num==7?'animate__animated animate__fadeInDown animate__delay-0s':''"><img src="../assets/expertimg/back-9-1.png"></div>
        <div class="gameBox-12" :class="num==7?'animate__animated animate__slideInLeft animate__delay-0s':''"><img src="../assets/expertimg/back-9-2.png"></div>
        <div class="gameBox-4" :class="num==7?'animate__animated animate__backInUp animate__delay-0s':''" @click="next"><img src="../assets/expertimg/down.png"></div>
      </swiper-slide>
      <swiper-slide>
        <img class="backimg" src="../assets/expertimg/back-5.png">
        <div class="gameBox-8" :class="num==8?'animate__animated animate__fadeInDown animate__delay-0s':''"><img src="../assets/expertimg/back-2-1.png"></div>
        <div class="gameBox-5" :class="num==8?'animate__animated animate__bounceInLeft animate__delay-0s':''"><img src="../assets/expertimg/back-2-2.png"></div>
        <div class="gameBox-6" :class="num==8?'animate__animated animate__bounceInLeft animate__delay-1s':''"><img src="../assets/expertimg/back-2-3.png"></div>
        <div class="gameBox-7" :class="num==8?'animate__animated animate__bounceInLeft animate__delay-2s':''"><img src="../assets/expertimg/back-2-4.png"></div>
        <div class="gameBox-11" :class="num==8?'animate__animated animate__bounceInLeft animate__delay-3s':''"><img src="../assets/expertimg/back-2-6.png"></div>
        <div class="gameBox-app" @click="appDow">
          <img src="../assets/expertimg/back-2-5.png">
        </div>
        <div class="gameBox-4" :class="num==8?'animate__animated animate__backInUp animate__delay-0s':''" @click="next"><img src="../assets/expertimg/down.png"></div>
      </swiper-slide>
      <swiper-slide>
        <img class="backimg" src="../assets/expertimg/back-4.png">
        <div class="gameBox-8" :class="num==9?'animate__animated animate__fadeInDown animate__delay-0s':''"><img src="../assets/expertimg/back-10-1.png"></div>
        <div class="gameBox-14" :class="num==9?'animate__animated animate__lightSpeedInRight animate__delay-0s':''"><img src="../assets/expertimg/back-10-2.png"></div>
        <div class="gameBox-wx" @click="share"><img src="../assets/expertimg/back-10-3.png"></div>
      </swiper-slide>
    </swiper>
    <van-overlay :show="openPopup" @click="openPopup = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="msgbox">
            <h3>专家招募</h3>
            <p>该专家招募请下载最新版中科名兽医APP</p>
            <div class="openapp-button" @click="openApp"><img src="../assets/liveimg/openapp-small.svg"></div>
          </div>
          <div class="old-close" @click="openPopup = false"><img src="../assets/liveimg/close.svg"></div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="openWx" @click="openWx = false">
      <div class="wrapper" @click="openWx = false">
        <div class="wx-back">
          <img src="../assets/expertimg/wx.png">
        </div>
      </div>
    </van-overlay>
  </div>
  
</template>

<script>
  import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
  import 'swiper/swiper-bundle.css'
  import { wxshare } from '@/utils/utils.js'
  export default {
    name: 'Expertrecruitment1',
    components: {
      Swiper,
      SwiperSlide
    },
    data() {
      return {
        height: '',
        width: document.documentElement.clientWidth,
        num: 0,
        img: 'https://zkjy.oss-cn-beijing.aliyuncs.com/2021/share/expertshare.png',
        title: '中科名兽医，专家招募活动开始啦！',
        desc: '诚挚邀请您加入名兽医团队，共同打造互联网兽医平台。',
        openPopup: false,
        openWx: false,
        isLoop: false,
        getApp: '',
        str: 1,

        swiperOption: {
          height: document.documentElement.clientHeight,
          width: document.documentElement.clientWidth,
          // effect : 'fade',
          // 分页器配置
          // pagination: {
          //   el: '.swiper-pagination',
          //   clickable: true
          // },
          // 箭头配置
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev'
          // },
          // 设定初始化时slide的索引
          initialSlide: 0,
          //Slides的滑动方向，可设置水平(horizontal)或垂直(vertical)
          direction: 'vertical',
          // 自动切换图配置
          autoplay: {
            delay: 6000,
            stopOnLastSlide: false,
            disableOnInteraction: true
          },
          followFinger : false,
          resistanceRatio : 0,
          // shortSwipes : false, // 短切换
          // 环状轮播
          loop: false,
          // slidesPerView: 'auto',
          // loopedSlides: 1,
          // loopAdditionalSlides: 0,
          // 一个屏幕展示的数量
          slidesPerView: 1,
          // 间距
          // spaceBetween: 26,
          // 修改swiper自己或子元素时，自动初始化swiper
          observer: true,
          // 修改swiper的父元素时，自动初始化swiper
          observeParents: true,
        }
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
    created(){
      this.getApp = this.$route.query.h5
      if (this.getApp == 'android') {
        this.swiperOption.height = Number(document.documentElement.clientHeight) + 10
      }
      console.log('this.getApp',this.getApp)
      wxshare(this.img,this.title,this.desc);
    },
    mounted() {
      console.log('clientHeight',this.swiperOption.height)
    },
    methods: {
      next() {
        // console.log('Current Swiper instance object', this.swiper)
        this.swiper.slideNext();
      },
      openApp() {
        window.location = 'http://t.cn/Aijv8II4'
      },
      appDow() {
        if (this.getApp == 'ios') {
          window.webkit.messageHandlers.goExpertReg.postMessage({name: 'zhangyutang', age: 12});
        } else if (this.getApp == 'android') {
          ZKAPP.goExpertReg();
        } else {
          this.openPopup = true
        }
      },
      share() {
        if (this.getApp == 'ios') {
          window.webkit.messageHandlers.goShare.postMessage({name: 'zhangyutang', age: 12});
        } else if (this.getApp == 'android') {
          ZKAPP.goShare();
        } else {
          this.openWx = true
        }
      },
      handleClickSlide(swiper) {
        this.num = swiper.realIndex
        console.log(swiper.isEnd);
        console.log('当前 Swipe 索引：' + this.num);
      },
    },
  }
</script>

<style lang="scss">
  .gameBox {
    // max-width: 768px;
    // margin: 0 auto;
    .duration {
      animation-duration: 2s; /* don't forget to set a duration! */
    }
    .backcolor {
      background: #127BE4;
      img {
        max-width: 100%;
      }
    }
    .backimg {
      width: 100%;
      height: 100%;
    }
    .gameBox-1 {
      position: absolute;
      bottom: 40%;
      left: 50%;
      margin-left: -170px;
      margin-bottom: -32.5px;
      img {
        width: 340px;
        height: 65px;
      }
    }
    .gameBox-2 {
      position: absolute;
      bottom: 28%;
      left: 50%;
      margin-left: -170px;
      margin-bottom: -37px;
      img {
        width: 340px;
        height: 74px;
      }
    }
    .gameBox-3 {
      position: absolute;
      bottom: 15%;
      left: 50%;
      margin-left: -170px;
      margin-bottom: -37px;
      img {
        width: 340px;
        height: 74px;
      }
    }
    .gameBox-4 {
      position: absolute;
      font-size: 0;
      bottom: 5%;
      left: 50%;
      margin-left: -22px;
      margin-bottom: -22px;
      z-index: 999;
      img {
        width: 44px;
        height: 44px;
      }
    }
    .gameBox-8 {
      position: absolute;
      top: 6%;
      left: 50%;
      margin-left: -160px;
      margin-bottom: -30px;
      img {
        width: 320px;
        height: 60px;
      }
    }
    .gameBox-9 {
      position: absolute;
      top: 20%;
      left: 50%;
      margin-left: -150px;
      margin-bottom: -30px;
      img {
        width: 300px;
        height: 60px;
      }
    }
    .gameBox-15 {
      position: absolute;
      top: 32%;
      left: 50%;
      margin-left: -150px;
      margin-bottom: -22px;
      img {
        width: 300px;
        height: 44px;
      }
    }
    .gameBox-16 {
      position: absolute;
      top: 44%;
      left: 50%;
      margin-left: -150px;
      margin-bottom: -21px;
      img {
        width: 300px;
        height: 42px;
      }
    }
    .gameBox-17 {
      position: absolute;
      top: 56%;
      left: 50%;
      margin-left: -150px;
      margin-bottom: -21px;
      img {
        width: 300px;
        height: 42px;
      }
    }
    .gameBox-10 {
      position: absolute;
      top: 22%;
      left: 50%;
      margin-left: -120px;
      margin-bottom: -200px;
      img {
        width: 230px;
        height: 390px;
      }
    }
    .gameBox-13 {
      position: absolute;
      top: 22%;
      left: 50%;
      margin-left: -120px;
      margin-bottom: -10px;
      img {
        width: 220px;
        height: 400px;
      }
    }
    .gameBox-12 {
      position: absolute;
      top: 30%;
      left: 50%;
      margin-left: -140px;
      margin-bottom: -170px;
      img {
        width: 280px;
        height: 280px;
      }
    }
    .gameBox-14 {
      position: absolute;
      top: 30%;
      left: 50%;
      margin-left: -150px;
      margin-bottom: -110px;
      img {
        width: 300px;
        height: 220px;
      }
    }
    .gameBox-5 {
      position: absolute;
      top: 15%;
      left: 50%;
      margin-left: -160px;
      margin-bottom: -27.5px;
      img {
        width: 320px;
        height: 60px;
      }
    }
    .gameBox-6 {
      position: absolute;
      top: 30%;
      left: 50%;
      margin-left: -160px;
      margin-bottom: -35px;
      img {
        width: 320px;
        height: 70px;
      }
    }
    .gameBox-7 {
      position: absolute;
      top: 45%;
      left: 50%;
      margin-left: -160px;
      margin-bottom: -32.5px;
      img {
        width: 320px;
        height: 65px;
      }
    }
    .gameBox-11 {
      position: absolute;
      top: 62%;
      left: 50%;
      margin-left: -150px;
      margin-bottom: -25px;
      img {
        width: 300px;
        height: 110px;
      }
    }
    .gameBox-app {
      position: absolute;
      bottom: 12%;
      left: 50%;
      margin-left: -80px;
      margin-bottom: -30px;
      img {
        width: 160px;
        height: 60px;
      }
    }
    .gameBox-wx {
      position: absolute;
      bottom: 15%;
      left: 50%;
      margin-left: -70px;
      margin-bottom: -27.5px;
      img {
        width: 140px;
        height: 55px;
      }
    }

    
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      font-size: 0;
      z-index: 9999;
    }

    .block {
      font-size: 0;
      text-align: center;
      .msgbox {
        width: 3rem;
        padding: 0.2rem 0 0.14rem;
        background-color: #fff;
        border-radius: 0.1rem;
        h3 {
          text-align: center;
          font-size: 0.15rem;
          font-weight: bold;
          padding-bottom: 0.2rem;
        }
        p {
          padding-bottom: 0.01rem;
          height: 0.2rem;
          line-height: 0.2rem;
          text-align: center;
          font-size: 0.14rem;
          color: #333;
          font-weight: 400;
        }
        .openapp-button {
          display: inline-block;
          padding-top: 0.2rem;
          width: 2.3rem;
          height: 0.54rem;
          img {
            width: 100%;
          }
        }
      }
      .old-close {
        display: inline-block;
        margin-top: 0.2rem;
        width: 0.35rem;
        height: 0.35rem;
        img {
          width: 0.35rem;
          height: 0.35rem;
        }
      }
    }

    .wx-back {
      position: fixed;
      top: 10px;
      right: 20px;
      img {
        width: 175px;
        height: 120px;
      }
    }
  }
</style>